import { breakpoints, pxToRems } from '@awaze/design-system.utils.react';
import styled, { css } from 'styled-components';
export const CarouselStyled = styled.div `
  position: relative;
  width: 100%;

  swiper-container::part(wrapper) {
    align-items: center;
  }

  ${({ stretchItems }) => stretchItems &&
    css `
      swiper-container::part(wrapper) {
        align-items: stretch !important;
        overflow: visible;
      }

      swiper-slide {
        height: auto !important;
      }
    `}

  /**
   * MAGIC NUMBERS: 48 relates to the prev and next arrow navigation element
   * size and 24 is the desired spacing between the image and the navigation
   * elements
   */
  ${({ horizontalPadding }) => horizontalPadding &&
    css `
      @media (min-width: ${breakpoints[1]}px) {
        swiper-container {
          margin-left: ${pxToRems(48 + 24)} !important;
          margin-right: ${pxToRems(48 + 24)} !important;
        }
      }
    `}


  // HACK: needed so carousel can grow to the height of the parent
  ${({ shouldFillHeight }) => shouldFillHeight &&
    css `
      height: 100%;
    `}
`;
export const CarouselNavigationElementStyled = styled.div `
  ${({ defaultNavigationButtonPosition }) => defaultNavigationButtonPosition &&
    css `
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
    `}
  z-index: 2;
  ${({ type }) => type === 'prev'
    ? css `
          left: ${pxToRems(16)};
        `
    : css `
          right: ${pxToRems(16)};
        `}

  ${({ applyResponsiveStyling = true, type }) => {
    if (!applyResponsiveStyling && type === 'prev') {
        return css `
        @media (min-width: ${breakpoints[0]}px) {
          left: ${pxToRems(24)};
        }
        @media (min-width: ${breakpoints[1]}px) {
          left: 0;
        }
      `;
    }
    if (!applyResponsiveStyling && type === 'next') {
        return css `
        @media (min-width: ${breakpoints[0]}px) {
          right: ${pxToRems(24)};
        }
        @media (min-width: ${breakpoints[1]}px) {
          right: 0;
        }
      `;
    }
}}
`;
export const CarouselPaginationElementStyled = styled.div `
  ${({ hasPagination }) => hasPagination &&
    css `
      margin-top: 24px;
    `}
  width: 100%;
  display: flex;
  justify-content: center;
`;
export const PaginationDivider = styled.div `
  margin-left: 5px;
  margin-right: 5px;
`;
export const PaginationCountContainer = styled.div `
  z-index: 2;
  height: 2rem;
  width: 61px;
  position: relative;
  top: -2rem;
  margin-bottom: -2rem;
  padding: 8px 0px 8px 8px;
  background-color: ${({ theme }) => theme.ColorBlackOpacity50};
  display: flex;
  flex-direction: row;
`;
export const PaginationCountText = styled.p `
  font-size: 12px;
  line-height: 16px;
  margin: 0 auto;
  color: ${({ theme }) => theme.ColorWhiteOpacity100};
  font-family: ${({ theme }) => theme.FontHeadingHeading500FontFamily};
`;
//# sourceMappingURL=carousel.styles.js.map